import React, { Fragment } from 'react';
import { ieCheck } from '../../helpers/utils';
import { IMAGE_SLICK_SETTINGS } from '../../config';
import Slider from "react-slick";
import _filter from 'lodash/filter';

const ImageSlider = (props) => {

  const imageObj = {
    imageQuality:60
  }

  const imageURL = (img) => {
    return (_filter(img, {'title': 'hero'})[0] && _filter(img, {'title': 'hero'})[0].url !== undefined) ? _filter(img, {'title': 'hero'})[0].url : "";
  }

  const standardImg = (img) => {
    return (
      <div>
        <img
          alt=""
          data-srcset={`https:${imageURL(img)}?w=562&q=${imageObj.imageQuality} 1x,
          https:${imageURL(img)}?w=862&q=${imageObj.imageQuality} 2x`}
          data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          className="lazyload" />
      </div>
    )
  }

  const ieImg = (img) => {
    return (
      <div>
      <img alt="" src={`https:${imageURL(img)}?w=562&q=${imageObj.imageQuality}`} />
      </div>
    )
  }

  return (
    <Slider {...IMAGE_SLICK_SETTINGS}>
      {
        props.images.map((item, i) => {
          return (
            <Fragment key={i}>
              { ieCheck() ? ieImg(props.iscyoa ? item.images : item)  : standardImg(props.iscyoa ? item.images : item) }
            </Fragment>
          )
        })
      }
    </Slider>
  )
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/shared/image-slider.js